// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { paginationQuerySchema } from '../../utils/listQuery.schema';

export const ruleListQuerySchema = paginationQuerySchema.and(
  z.object({
    schema: idSchema.optional(),
    queue: z.union([idSchema, z.array(idSchema)]).optional(),
    enabled: z.string().optional(),
    linked: z.string().optional(),
    actions: z.union([z.string(), z.array(z.string())]).optional(),
  })
);
